export default __webpack_public_path__ + "static/thebottomline32-7965130920a59a14845213ff16be3e29.jpg";